cb.define([], function () {
  var AA_aa_warehouselist_VM_extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		var self = this;
		
		let gridModel = viewmodel.getGridModel();
		gridModel.on('afterSetDataSource', () => {
			const rows = gridModel.getRows();
			const actions = gridModel.getCache('actions');
			const actionsStates = [];
			rows.forEach(data => {
				const actionState = { };
				actions.forEach(action => {
					actionState[action.cItemName] = { visible: true };
					if (data.enableState == "enable") {
						actionState["btnUnStop1"] = { visible: false };
						actionState["btnStop1"] = { visible: true };
					}
					if (data.enableState == "disable") {
						actionState["btnStop1"] = { visible: false };
						actionState["btnUnStop1"] = { visible: true };

					}
				  });
				actionsStates.push(actionState);
			});
			gridModel.setActionsState(actionsStates);
		});
		
		viewmodel.getGridModel().setShowCheckbox(false);
    },
  }
  try {
    module.exports = AA_aa_warehouselist_VM_extend;
  } catch(error){
  }
  return AA_aa_warehouselist_VM_extend;

});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_aa_warehouselist_VM.Extend.js